/* eslint-disable no-mixed-operators */
import React, { useRef, useState, useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    adminLogin,
    checkAdminEmail
} from '../../../api/apiServices';
import toast, { Toaster } from 'react-hot-toast'
import './Login.css';


const TryLogin = () => {
    const { setAuth, persist, setPersist } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/admin/dashboard";

    const userRef = useRef();

    const [state, setState] = useState({
        email: "",
        password: "",
        isFirstTimeLogin: false,
    })

    useEffect(() => {
        userRef.current.focus();
        // userPswd.current.focus();
    }, [])


    const handleEmail = async () => {

        let adminEmail = state.email;
        if (!adminEmail) {
            toast.error("Please enter your email address", {
                className: "toast-message",
            });
            return false;
        } else {
            try {
                let sendData = [];
                checkAdminEmail(adminEmail).then((hasPswd) => {
                    if (hasPswd.status === 'not_found') {
                        toast.error(hasPswd.message, {
                            duration: 5000,
                            className: "toast-message",
                        });
                        setState({
                            ...state,
                            isFirstTimeLogin: state.isFirstTimeLogin
                        })
                        userRef.current.focus();
                        return false
                    }
                    if (hasPswd.status === 'blocked') {
                        toast.error(hasPswd.message, {
                            duration: 5000,
                            className: "toast-message",
                        });
                        setState(prevState =>({
                            ...prevState,
                            email: "",
                            isFirstTimeLogin: state.isFirstTimeLogin
                        }))
                        userRef.current.focus();
                        return false;
                    }
                    if (!hasPswd.status) {
                        let useData = hasPswd.data;
                        function extractData() {
                            sendData = Object.keys(useData).map(function (key) {
                                return useData[key];
                            }).join('&');
                        }
                        extractData();
                        window.location.replace(`/set_password?user=${sendData}`);
                    } else {
                        setState({
                            ...state,
                            isFirstTimeLogin: !state.isFirstTimeLogin
                        });
                        userRef.current.focus();
                        return true
                    }
                }).catch((error) => {
                    console.log(error)
                })
            } catch (err) {
                if (err.response?.status === 400) {
                    toast.error('Missing Email or Password', {
                        duration: 5000,
                        className: "toast-message",
                    });

                } else if (err.response?.status === 401) {
                    toast.error('Email address not found', {
                        duration: 5000,
                        className: "toast-message",
                    });

                } else {
                    toast.error('Login Failed', {
                        duration: 5000,
                        className: "toast-message",
                    });
                }
            }
        }
    }
    const handleChange = (e) => {
        e.preventDefault();
        const value = e.target.value
        setState({
            ...state,
            [e.target.name]: value
        })

    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!state.email && !state.password) return false;
        const data = {
            email: state.email,
            password: state.password
        }
        try {
            adminLogin(data).then((response) => {
                if (response.status === true) {
                    const user_role = response?.user_role;
                    const email = response?.email;
                    const username = response?.username;
                    const accessToken = response?.accessToken;

                    setAuth({ user_role, username, email, accessToken });
                    setState({
                        ...state,
                        email: "",
                        password: "",
                    });
                    navigate(from, { replace: true });
                }
                if (response.status === false &&
                    response.login_attempts === 3 ||
                    response.account_blocked) {
                    toast.error(response.message, {
                        duration: 5000,
                        className: "toast-message",
                    });
                    setState({
                        ...state,
                        pf_number: "",
                        password: "",
                        isFirstTimeLogin: state.isFirstTimeLogin
                    });
                    return false
                }
                if (response.status === false) {
                    toast.error(response.message, {
                        duration: 5000,
                        className: "toast-message",
                    });
                    setState({
                        ...state,
                        password: "",
                        isFirstTimeLogin: state.isFirstTimeLogin
                    });
                    return false
                }
            })
        } catch (err) {
            if (err.response?.status === 400) {
                toast.error('Missing Email or Password', {
                    duration: 5000,
                    className: "toast-message",
                });
                toast.error('Missing Email or Password', {
                    duration: 5000,
                    className: "toast-message",
                });
            } else if (err.response?.status === 401) {
                toast.error('Wrond Username or Password', {
                    duration: 5000,
                    className: "toast-message",
                });
            } else {
                toast.error('Login failed', {
                    duration: 5000,
                    className: "toast-message",
                });
            }
        }
    }
    const togglePersist = () => {
        setPersist(prev => !prev);
    }

    useEffect(() => {
        localStorage.setItem('persist', persist)
    }, [persist])

    return (
        <>
            <Toaster toastOptions={{ position: "top-center" }} />
            <div className="admin-wrapper">
                <div className="login-container">
                    <div className="login-image">
                        <img className='logo-img' src='/images/logos/proforum_main.jpg' alt='proforum' />
                    </div>
                    <form className="form" onSubmit={handleSubmit}>
                        <fieldset>
                            <legend className='login-title'>Admin Login</legend>
                            {!state.isFirstTimeLogin ? (
                                <>
                                    <label htmlFor="email" className='label-login'>Email Address</label>
                                    <div className="input-group success">
                                        <input
                                            ref={userRef}
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder='Email Address'
                                            autoComplete="off"
                                            value={state.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div></>
                            ) : (null)}
                            {!state.isFirstTimeLogin ? (
                                <>
                                    <button onClick={handleEmail} type="button" className="main-btn btn-success">Next</button>
                                </>
                            ) : (
                                <>
                                    <label htmlFor="password" className='label-login'>Password</label>
                                    <div className="input-group error">
                                        <input
                                            ref={userRef}
                                            name="password"
                                            type="password"
                                            id="password"
                                            autoComplete="off"
                                            value={state.password}
                                            placeholder="Password"
                                            required
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-success btn-block login-button">Login</button>
                                </>
                            )}
                            <div className='persistCheck'>
                                <input
                                    type='checkbox'
                                    id='persist'
                                    onChange={togglePersist}
                                    checked={persist}
                                />
                                <label htmlFor='persist'> Remember me on this device</label>
                            </div>
                        </fieldset>
                        <hr />
                        <p><em>By logging in to the NDC Professionals Forum Membership Management System, you agree to comply fully to the Secrecy and Privacy of members records.</em></p>
                    </form>
                </div>
            </div>
        </>
    )
}

export default TryLogin